import { takeLatest } from "redux-saga/effects";
import {
  AddToCart,
  Cancel,
  CreateOrder,
  DownloadPI,
  ExportFile,
  GetCart,
  OpenOrders,
  OpenProducts,
  OrderGetComments,
  Origins,
  Payments,
  UpdateInvoice,
  UploadProfomaDoc,
  ClearCart,
} from "./Action";
import { apis } from "../../config/apis";
import { sagaFunctions } from "../../config/helper";
import { Addresses, Regions, Products } from "./Action";
import {
  DeleteItemFromCart,
  GetOrder,
  GetOrders,
  OrderAddComments,
  OrderHistory,
  OrderRepeat,
  OrderUpdate,
  ProductFilters,
  UpdateCart,
} from ".";

function addresses(req) {
  return sagaFunctions(Addresses, "get", apis.addresses, req.payload)();
}

function payments(req) {
  return sagaFunctions(Payments, "get", apis.payments, req.payload)();
}

function orders(req) {
  return sagaFunctions(GetOrders, "get", apis.orders, req.payload)();
}

function regions(req) {
  return sagaFunctions(Regions, "get", apis.regions, req.payload)();
}

function origins(req) {
  return sagaFunctions(Origins, "get", apis.origins, req.payload)();
}

function products(req) {
  let list_prod = req.payload.list_prod
  delete req.payload.list_prod
  console.log(req);
  return sagaFunctions(
    Products,
    "get",
    list_prod ? apis.list_products : apis.products,
    req.payload
  )();
}

function add_to_cart(req) {
  return sagaFunctions(AddToCart, "post", apis.line_items, req.payload)();
}

function create_order(req) {
  return sagaFunctions(CreateOrder, "post", apis.orders, req.payload)();
}

function get_cart(req) {
  return sagaFunctions(
    GetCart,
    "get",
    apis.carts + "/" + localStorage.getItem("cartId"),
    req.payload
  )();
}

function clear_cart(req) {
  return sagaFunctions(
    ClearCart,
    "post",
    apis.clear_cart(req.payload.cartId),
    req.payload
  )();
}

function get_prod_filters(req) {
  return sagaFunctions(
    ProductFilters,
    "get",
    apis.product_filters,
    req.payload
  )();
}

function update_cart(req) {
  let id = req.payload.product_id;
  delete req.payload.product_id;
  return sagaFunctions(
    UpdateCart,
    "post",
    apis.update_line_items(id),
    req.payload
  )();
}

function delete_from_cart(req) {
  let id = req.payload.id;
  delete req.payload.id;
  return sagaFunctions(
    DeleteItemFromCart,
    "post",
    apis.line_items + "/" + id,
    req.payload
  )();
}

function order(req) {
  let id = req.payload.orderId;
  delete req.payload.orderId;
  return sagaFunctions(GetOrder, "get", apis.orders + "/" + id, req.payload)();
}

function openOrders(req) {
  return sagaFunctions(OpenOrders, "get", apis.customer_open_product_orders, req.payload)();
}

function downloadPI(req) {
  return sagaFunctions(DownloadPI, "get", apis.download_signed_perofoma_invoice, req.payload)();
}

function openProducts(req) {
  return sagaFunctions(OpenProducts, "get", apis.customer_open_order_products, req.payload)();
}

function cancleOrder(req) {
  return sagaFunctions(Cancel, "post", `${apis.cancle_order}?email=${localStorage.getItem(
    "email"
  )}`, req.payload)();
}

function updateOrder(req) {
  return sagaFunctions(
    OrderUpdate,
    "post",
    `${apis.update_order}?email=${localStorage.getItem(
      "email"
    )}`,
    req.payload
  )();
}

function orderRepeat(req) {
  return sagaFunctions(
    OrderRepeat,
    "post",
    `${apis.order_repeat}?email=${localStorage.getItem(
      "email"
    )}`,
    req.payload
  )();
}

function orderAddComments(req) {
  return sagaFunctions(
    OrderAddComments,
    "post",
    `${apis.add_comments}?email=${localStorage.getItem(
      "email"
    )}`,
    req.payload
  )();
}

function orderGetComments(req) {

  console.log(req.payload);
  return sagaFunctions(
    OrderGetComments,
    "get",
    `${apis.get_comments}`,
    req.payload
  )();
}

function updateInvoice(req) {
  return sagaFunctions(
    UpdateInvoice,
    "post",
    `${apis.invoice_status_update}?email=${localStorage.getItem(
      "email"
    )}`,
    req.payload
  )();
}
function uploadPerfomaDoc(req) {
  return sagaFunctions(
    UploadProfomaDoc,
    "post",
    `${apis.upload_preshipment_file}?email=${localStorage.getItem(
      "email"
    )}`,
    req.payload, {
    "Content-Type": "multipart/form-data"
  }
  )();
}

function orderHistory(req) {
  return sagaFunctions(OrderHistory, "get", apis.order_history, req.payload)();
}

function exportFile(req) {
  return sagaFunctions(ExportFile, "get", apis.export_product_file, req.payload)();
}

export function* ordersWatcher() {
  yield takeLatest(Addresses.REQUEST, addresses);
  yield takeLatest(ExportFile.REQUEST, exportFile);
  yield takeLatest(Cancel.REQUEST, cancleOrder);
  yield takeLatest(DownloadPI.REQUEST, downloadPI);
  yield takeLatest(UploadProfomaDoc.REQUEST, uploadPerfomaDoc);
  yield takeLatest(UpdateInvoice.REQUEST, updateInvoice);
  yield takeLatest(Payments.REQUEST, payments);
  yield takeLatest(OrderAddComments.REQUEST, orderAddComments);
  yield takeLatest(OrderGetComments.REQUEST, orderGetComments);
  yield takeLatest(OrderHistory.REQUEST, orderHistory);
  yield takeLatest(OrderUpdate.REQUEST, updateOrder);
  yield takeLatest(Regions.REQUEST, regions);
  yield takeLatest(Origins.REQUEST, origins);
  yield takeLatest(Products.REQUEST, products);
  yield takeLatest(AddToCart.REQUEST, add_to_cart);
  yield takeLatest(GetCart.REQUEST, get_cart);
  yield takeLatest(ClearCart.REQUEST, clear_cart);
  yield takeLatest(CreateOrder.REQUEST, create_order);
  yield takeLatest(DeleteItemFromCart.REQUEST, delete_from_cart);
  yield takeLatest(GetOrders.REQUEST, orders);
  yield takeLatest(GetOrder.REQUEST, order);
  yield takeLatest(UpdateCart.REQUEST, update_cart);
  yield takeLatest(ProductFilters.REQUEST, get_prod_filters);
  yield takeLatest(OrderRepeat.REQUEST, orderRepeat);
  yield takeLatest(OpenOrders.REQUEST, openOrders);
  yield takeLatest(OpenProducts.REQUEST, openProducts);
}
